import React, { FC } from "react";
import {
	makeStyles,
	DialogActionsProps,
	DialogActions,
} from "@material-ui/core";

const ModalActions: FC<DialogActionsProps> = (props) => {
	const classes = useStyles();

	return <DialogActions {...props} className={classes.root} />;
};

export default ModalActions;

const useStyles = makeStyles({
	root: {
		display: "flex",
		justifyContent: "space-between",
		// boxShadow: "0 -2px 7px 0 rgba(0, 0, 0, 0.15)",
		"& > *:only-of-type": {
			marginLeft: "auto",
			marginRight: "auto",
		},
	},
});
